import { getTrackingConsent } from './consent';

type MetaPixel = ((command: string, eventName: string, parameters?: Record<string, string | number>, options?: { eventID: string }) => void) & {
  callMethod?: MetaPixel;
  queue?: unknown[][];
  push?: MetaPixel;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}

let initializedPixelId: string | null = null;

export function initMetaPixel(): boolean {
  if (typeof window === 'undefined' || getTrackingConsent() !== 'granted') return false;

  const pixelId = process.env.META_PIXEL_ID?.trim();
  if (!pixelId) return false;
  if (initializedPixelId === pixelId && window.fbq) return true;

  if (!window.fbq) {
    const fbq = ((command: string, eventName: string, parameters?: Record<string, string | number>, options?: { eventID: string }) => {
      if (fbq.callMethod) fbq.callMethod(command, eventName, parameters, options);
      else fbq.queue?.push([
        command,
        eventName,
        ...(parameters === undefined ? [] : [parameters]),
        ...(options === undefined ? [] : [options]),
      ]);
    }) as MetaPixel;
    fbq.queue = [];
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    window.fbq = fbq;
    window._fbq = fbq;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }

  window.fbq('init', pixelId);
  window.fbq('track', 'PageView');
  initializedPixelId = pixelId;
  return true;
}

export function trackMetaEvent(
  eventName: string,
  parameters: Record<string, string | number> = {},
  eventId?: string,
) {
  if (!initMetaPixel() || !window.fbq) return;

  const options = eventId ? { eventID: eventId } : undefined;
  window.fbq('track', eventName, parameters, options);
}
